import { takeEvery, takeLatest, call, select, put } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import { APP_INITIALIZED, SYNC_LOGGED_IN_USER } from './app';
import {
    AUTH_LEVEL_CHECK,
    LOGIN,
    SIGNUP,
    MERGE_ACCOUNT,
    PROCESS_PAYMENT,
    getCompanyPositions,
    startMergeRequestAction,
} from './auth';
import { showSnackbarAction } from './snackbar';

export const FETCH_ME = 'me/FETCH_ME';
export const SET_ME = 'me/SET_ME';
export const CHANGE_USER_INFO = 'me/CHANGE_USER_INFO';

export default function reducer(state = null, action) {
    switch (action.type) {
        case SET_ME:
            if (action.payload.user) {
                return {
                    ...action.payload.user,
                };
            }
            return state;
        case actionKey.success(CHANGE_USER_INFO):
            return {
                ...state,
                ...action.payload,
            };
        case actionKey.success(PROCESS_PAYMENT):
            return {
                ...state,
                isPaying: true,
            };
        default:
            return state;
    }
}

export const changeUserInfoAction = payload => ({
    type: CHANGE_USER_INFO,
    ...payload,
});

export const setMeAction = payload => ({
    type: SET_ME,
    payload,
});

export function* rootSaga() {
    yield [
        takeLatest([
            APP_INITIALIZED,
            actionKey.success(AUTH_LEVEL_CHECK),
        ], fetchMe),
        takeEvery(CHANGE_USER_INFO, changeUserInfo),
        takeEvery([
            SYNC_LOGGED_IN_USER,
            actionKey.success(MERGE_ACCOUNT),
            actionKey.success(FETCH_ME),
            actionKey.success(LOGIN),
            actionKey.success(SIGNUP),
        ], setMe),
    ];
}

export function* setMe({ payload, type }) {
    const { auth } = yield select();
    if (type === actionKey.success(SIGNUP) && (!auth || !auth.token)) {
        return;
    }
    yield put(setMeAction(payload));
}

const noop = () => null;

export function* changeUserInfo({
    type, reject = noop, resolve = noop, ...payload
}) {
    const { me } = yield select();
    const { positionType } = me;
    const positions = getCompanyPositions({
        companyPositions: payload.companyPositions,
        positionType: payload.positionType || positionType,
    });
    const result = yield call(request, {
        url: '/api/me',
        type,
        options: {
            method: 'PUT',
            body: {
                ...payload,
                companyPositions: positions,
            },
        },
    });
    if (result && result.error) {
        if (result.status === 409) {
            yield put(startMergeRequestAction(payload.secondaryEmail));
            resolve();
            return;
        }
        reject(new SubmissionError({
            _error: result.error,
        }));
    } else {
        resolve();
        yield put(showSnackbarAction({
            message: 'Account Setting Successfully Updated',
            type: 'success',
            timeout: 2000,
        }));
    }
}

export function* fetchMe() {
    const { auth } = yield select();
    if (!auth || !auth.token) {
        return;
    }
    yield call(request, {
        url: '/api/me',
        type: FETCH_ME,
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/me.js